import React, {useEffect, useRef, useState} from 'react';
import { useSelector } from "react-redux";
import { v4 as uuidv4 } from "uuid";

export default function ProfilCorrespondant() {

    const {
        keycloakReduce,
        infosCorrespondant,
    } = useSelector(state => ({
        ...state.keycloakReducer,
    }))

    console.log("|||||-----|||||")
    console.log("ProfilCorrespondant")
    console.log("infosCorrespondant")
    console.log(infosCorrespondant)

    return (
        <div className={ 'container' }>
            <main id='content' className='mt-3'>
                <h1>Profil</h1>
                <h2>Identité</h2>

                <div className="row">
                    <div className="col-md-4">
                        <span>
                            <span className='bold'>Civilité :</span> { infosCorrespondant?.civilite }
                        </span>
                    </div>
                    <div className="col-md-4">
                        <span>
                            <span className='bold'>Nom :</span> { infosCorrespondant?.nom }
                        </span>
                    </div>
                    <div className="col-md-4">
                        <span>
                            <span className='bold'>Prénom :</span> { infosCorrespondant?.prenom }
                        </span>
                    </div>
                    <div className="col-md-4">
                        <span>
                            <span
                                className='bold'>Email :
                            </span> { infosCorrespondant?.courriel ? infosCorrespondant?.courriel : <span className={ 'ms-5' }>-</span>}
                        </span>
                    </div>
                      <div className="col-md-8">
                        <span>
                            <span
                                className='bold'>Téléphone :
                            </span> { infosCorrespondant?.numTel ? infosCorrespondant?.numTel : <span className={ 'ms-5' }>-</span>}
                        </span>
                    </div>
                     <div className="col-md-4">
                        <span>
                            <span
                                className='bold'>Numéro de contrat :
                            </span> { infosCorrespondant?.numContrat ? infosCorrespondant?.numContrat : <span className={ 'ms-5' }>-</span>}
                        </span>
                    </div>
                    <div className="col-md-8">
                        <span>
                            <span
                                className='bold'>Numéro personne correspondant :</span> { infosCorrespondant?.numPersCorr }
                        </span>
                    </div>
                </div>

                <h2 className={ 'mt-3' }>Établissements</h2>

                <div className='table-responsive-lg'>

                    <table className="table">
                        <thead>
                        <tr>
                            <th>Raison sociale</th>
                            <th>Adresse</th>
                            <th>Fonction</th>
                            <th>Coordonnées</th>
                        </tr>
                        </thead>

                        <tbody>
                        { infosCorrespondant?.etablissements?.length > 0 && infosCorrespondant?.etablissements?.map(etablissement => (
                            // eslint-disable-next-line react/jsx-key
                            <tr key={ uuidv4() }>
                                <td>{ etablissement?.raisonSociale }</td>
                                <td>
                                    <div>{ etablissement?.ligAdresse1 }</div>
                                    <div>{ etablissement?.codePostal } { etablissement?.ville }</div>
                                </td>
                                <td>
                                    <div>{ etablissement?.typeFonction }</div>
                                </td>
                                <td>
                                    <div><span className='bold'>Téléphone :</span> { etablissement?.numTel }</div>
                                    { etablissement?.numFax &&
                                        <div><span className='bold'>Fax :</span> { etablissement?.numFax }</div> }
                                    <div><span className='bold'>Email :</span> { etablissement?.courriel }</div>
                                </td>
                            </tr>
                        )) }
                        </tbody>
                    </table>
                </div>

            </main>
        </div>
    )
}